import clsx from "clsx";
import React from "react";
import box from "../../../images/icons/box.svg";

const Empty = ({ children, className }) => {
  return (
    <div
      className={clsx(
        "flex flex-col gap-2 mx-auto mt-[90px] items-center",
        className
      )}
    >
      <img src={box} alt="" className="w-[100px] h-[100px]" />

      <p className="text-minimal text-dimgray-200 font-notosans">{children}</p>
    </div>
  );
};

export default Empty;
